'use client';

import { c as _c } from "react/compiler-runtime";
import { cx } from '@7f-ui';
import { IconButton } from '@7f-ui/components/button/icon-button';
import { ImageSliderLightbox } from '@7f-ui/components/image-slider/image-slider-lightbox';
import { ImageSliderSwipeDots } from '@7f-ui/components/image-slider/image-slider-swipe-dots';
import { SimpleModal } from '@7f-ui/components/modal/simple-modal';
import { mapWishlistProduct } from '@feat/feat-wishlists/product';
import { WishlistToggle } from '@feat/feat-wishlists/toggle';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { shopTestId } from '@utils/utils-shop-test-ids';
import Image from 'next/image';
import type { KeyboardEvent } from 'react';
import { useState } from 'react';
import type { HeroSectionProps } from '.';
import { getInitialTweenTransform, useHeroCarousel } from './use-hero-carousel';
export const HeroMobile = t0 => {
  const $ = _c(42);
  const {
    images,
    product
  } = t0;
  let t1;
  if ($[0] !== images || $[1] !== product) {
    t1 = product ? mapWishlistProduct(product, images) : null;
    $[0] = images;
    $[1] = product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const productProps = t1;
  const {
    emblaRef,
    currentIndex,
    scrollPrev,
    scrollNext
  } = useHeroCarousel();
  const [lightboxOpen, setLightboxOpen] = useState(false);
  let t2;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = e => {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setLightboxOpen(true);
      }
    };
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const handleKeyDown = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = shopTestId("HeroMobile");
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== productProps) {
    t4 = productProps && <div className="absolute top-10 right-10 z-10 inline-flex"><WishlistToggle {...productProps} iconOnly={true} /></div>;
    $[5] = productProps;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setLightboxOpen(true);
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== images) {
    t6 = images.map(_temp);
    $[8] = images;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== t6) {
    t7 = <div className="embla__container flex">{t6}</div>;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== emblaRef || $[13] !== t7) {
    t8 = <div className="embla__viewport" ref={emblaRef}>{t7}</div>;
    $[12] = emblaRef;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  const t9 = currentIndex + 1;
  let t10;
  if ($[15] !== images.length || $[16] !== t9) {
    t10 = <div className="absolute right-10 bottom-4 inline-flex items-center justify-center rounded-md bg-black/50 px-2 py-0.5"><div className="text-center font-base-copy font-semibold text-white">{t9}/{images.length}</div></div>;
    $[15] = images.length;
    $[16] = t9;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== currentIndex || $[19] !== images.length) {
    t11 = images.length > 1 && <div className="pointer-events-none absolute bottom-4 left-0 flex w-full justify-center space-x-2"><ImageSliderSwipeDots currentIndex={currentIndex} length={images.length} /></div>;
    $[18] = currentIndex;
    $[19] = images.length;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== scrollPrev) {
    t12 = <div className="embla__prev absolute top-0 left-4 flex h-full items-center opacity-0 transition-opacity group-hover/carousel:opacity-100"><IconButton Icon={CaretLeft} variant="faded" size="small" aria-label="Previous" onClick={e_0 => {
        e_0.stopPropagation();
        scrollPrev();
      }} /></div>;
    $[21] = scrollPrev;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== scrollNext) {
    t13 = <div className="embla__next absolute top-0 right-4 flex h-full items-center opacity-0 transition-opacity group-hover/carousel:opacity-100"><IconButton Icon={CaretRight} variant="faded" size="small" aria-label="Next" onClick={e_1 => {
        e_1.stopPropagation();
        scrollNext();
      }} /></div>;
    $[23] = scrollNext;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== t10 || $[26] !== t11 || $[27] !== t12 || $[28] !== t13 || $[29] !== t8) {
    t14 = <div className="embla group/carousel relative overflow-hidden px-6 pt-6" onClick={t5} onKeyDown={handleKeyDown} role="button" tabIndex={0} aria-label="Open image gallery">{t8}{t10}{t11}{t12}{t13}</div>;
    $[25] = t10;
    $[26] = t11;
    $[27] = t12;
    $[28] = t13;
    $[29] = t8;
    $[30] = t14;
  } else {
    t14 = $[30];
  }
  let t15;
  if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = () => setLightboxOpen(false);
    $[31] = t15;
  } else {
    t15 = $[31];
  }
  let t16;
  if ($[32] !== currentIndex || $[33] !== images) {
    t16 = <ImageSliderLightbox images={images} initialIndex={currentIndex} />;
    $[32] = currentIndex;
    $[33] = images;
    $[34] = t16;
  } else {
    t16 = $[34];
  }
  let t17;
  if ($[35] !== lightboxOpen || $[36] !== t16) {
    t17 = <SimpleModal isOpen={lightboxOpen} onClose={t15} height="full" size="full">{t16}</SimpleModal>;
    $[35] = lightboxOpen;
    $[36] = t16;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t14 || $[39] !== t17 || $[40] !== t4) {
    t18 = <div data-testid={t3} className="sm:hidden">{t4}{t14}{t17}</div>;
    $[38] = t14;
    $[39] = t17;
    $[40] = t4;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  return t18;
};
function _temp(image, index) {
  return <div className={cx("embla__slide relative aspect-4/3 min-w-0 shrink-0 grow-0 basis-full transition-opacity", index === 0 ? "z-10 opacity-100" : "opacity-70")} key={image.url}><Image src={image.url} alt={image.alt ?? ""} fill={true} sizes="320px" quality={50} className="embla__slide__image rounded-xl object-cover" style={{
      transform: getInitialTweenTransform(index)
    }} preload={index === 0} fetchPriority={index === 0 ? "high" : "low"} /></div>;
}